import DefaultDetailedProjectReport from "src/components/feature/DetailedProjectReport";

const DetailedProjectReport = () => {
  return <DefaultDetailedProjectReport />;
};

export default DetailedProjectReport;
